module.exports = __webpack_public_path__ + "static/ko-7127ed2811a26d66de0c57e582e3c288.svg";